import React from 'react';

function HomePage({ user }) {
  return (
    <div>
      <header>
        <img
          src={user.avatar || "https://via.placeholder.com/50"}
          alt="Avatar"
          style={{ borderRadius: '50%', width: '50px', height: '50px' }}
        />
        <span>{user.name}</span>
      </header>
      <h1>Welcome to the Home Page</h1>
      <p>This is the main content area of the site.</p>
    </div>
  );
}

export default HomePage;
